import { Heading, VFlow } from 'bold-ui'
import React from 'react'
import { HistoricoMedicaoModel } from 'view/atendimentos/types/model-historicoMedicao'

import { MedicaoAnteriorModel } from '../model-medicoes'
import { HistoricoMedicoesExameFisicoTable } from './HistoricoMedicoesExameFisicoTable'
import { MedicaoExameFisicoAnteriorForm } from './MedicaoExameFisicoAnteriorForm'

interface HistoricoMedicoesExameFisicoViewProps {
  dataNascimentoCidadao: LocalDate
  dataAtendimento: Instant
  medicoes: ReadonlyArray<HistoricoMedicaoModel>
  isAtendimentoObservacao: boolean
  canEditOrAdd: boolean
  onAddMedicaoAnterior?: (medicao: MedicaoAnteriorModel) => void
  onRemoveMedicaoAnterior?: (id: ID) => void
}

export function HistoricoMedicoesExameFisicoView(props: Readonly<HistoricoMedicoesExameFisicoViewProps>) {
  const {
    dataAtendimento,
    dataNascimentoCidadao,
    medicoes,
    isAtendimentoObservacao = false,
    canEditOrAdd = false,
    onAddMedicaoAnterior,
    onRemoveMedicaoAnterior,
  } = props

  return (
    <VFlow>
      <Heading level={4}>Avaliação de força muscular</Heading>
      {canEditOrAdd && onAddMedicaoAnterior && (
        <MedicaoExameFisicoAnteriorForm
          dataAtendimento={dataAtendimento}
          dataNascimentoCidadao={dataNascimentoCidadao}
          onSubmit={onAddMedicaoAnterior}
        />
      )}
      <HistoricoMedicoesExameFisicoTable
        medicoes={medicoes}
        isAtendimentoObservacao={isAtendimentoObservacao}
        onRemove={onRemoveMedicaoAnterior}
      />
    </VFlow>
  )
}
